import * as React from 'react';
import { campaignSessionStore, CampaignSession } from './campaignSessionStore';
import { ResourceStatus } from './types';

/**
 * Hook to subscribe to campaign session store updates
 * Provides reactive access to store state without MobX
 */
export const useCampaignSessionStore = () => {
	const [, forceUpdate] = React.useReducer((x: number) => x + 1, 0);

	React.useEffect(() => {
		const unsubscribe = campaignSessionStore.subscribe(() => {
			forceUpdate();
		});

		return unsubscribe;
	}, []);

	return {
		currentSession: campaignSessionStore.currentSession,
		shouldOpenAIDrawer: campaignSessionStore.shouldOpenAIDrawer,
		hasActiveSession: campaignSessionStore.hasActiveSession,
		incompleteResources: campaignSessionStore.incompleteResources,
		completedResources: campaignSessionStore.completedResources,
		secondaryResources: campaignSessionStore.secondaryResources,
		aiSourceContent: campaignSessionStore.aiSourceContent,
		aiSourceType: campaignSessionStore.aiSourceType,
	};
};

/**
 * Hook to get the current session
 */
export const useCurrentSession = (): CampaignSession | null => {
	const { currentSession } = useCampaignSessionStore();
	return currentSession;
};

/**
 * Hook to get secondary resources
 */
export const useSecondaryResources = (): ResourceStatus[] => {
	const { secondaryResources } = useCampaignSessionStore();
	return secondaryResources;
};

/**
 * Hook to check if there's an active session
 */
export const useHasActiveSession = (): boolean => {
	const { hasActiveSession } = useCampaignSessionStore();
	return hasActiveSession;
};
